import { Button, Stack } from "@mui/material";

import { AddRoutePointETAButton } from "components/AddRoutePointETAButton";
import { LatestShipmentRoutePointETADisplay } from "components/LatestShipmentRoutePointETADisplay";
import { ShipmentStatusHistoryTable } from "components/ShipmentStatusHistoryTable";
import { useDisclosure, useShipperShipmentPageContext } from "hooks";

import { ShipmentStateDisplay } from "./ShipmentStateDisplay";
import { ShipmentMicroReviewMenu } from "../ShipmentMicroReviewMenu";

interface Props {
  dividerComponent: JSX.Element;
}

export function ShipmentStateSection(props: Props) {
  const { dividerComponent } = props;
  const { shipment, onRefresh } = useShipperShipmentPageContext();
  const {
    isOpen: historyOpen,
    onClose: onCloseHistory,
    onOpen: onOpenHistory,
  } = useDisclosure(false);

  // scenarios where no component is rendered.
  if (
    !shipment ||
    shipment.shipment_status === "ACTIVE" ||
    shipment.shipment_status === "CANCELLED" ||
    shipment?.info?.booked_at == null ||
    shipment.info.type === "MULTI_SHIPMENT_PROJECT"
  ) {
    return null;
  }
  return (
    <Stack mb="1.5rem">
      {dividerComponent}
      <ShipmentMicroReviewMenu
        shipment={shipment}
        onShipmentMicroReviewSuccess={onRefresh}
      />
      <Stack direction="column" spacing={1}>
        <ShipmentStateDisplay />
        <LatestShipmentRoutePointETADisplay shipment={shipment} />
      </Stack>
      <Stack id="button-container" sx={{ pt: "1rem" }} direction="row">
        <Stack width="50%" direction="row" justifyContent="left" spacing={3}>
          <AddRoutePointETAButton
            shipment={shipment}
            onETACreatedSuccess={onRefresh}
          />
        </Stack>
        <Stack width="50%" direction="row" justifyContent="right">
          <Button
            variant="text"
            onClick={historyOpen ? onCloseHistory : onOpenHistory}
          >
            {historyOpen ? "Hide history" : "Show history"}
          </Button>
        </Stack>
      </Stack>
      {historyOpen && <ShipmentStatusHistoryTable shipment={shipment} />}
    </Stack>
  );
}
